import { useGetPublicCareerSiteQuery } from '@front/api/service-career-neo/useGetPublicCareerSiteQuery'
import { Box, Stack } from '@mui/material'
import {
  Heading2,
  TextBody,
} from '@front/components/data-display/typography/Typography'
import { useTranslation } from 'react-i18next'
import { WorkOutlineOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'
import { EmptyState } from '../shared/empty-state/EmptyState'

type TabProps = {
  slug: string
}

export default function PresentationTab({ slug }: TabProps) {
  const theme = useTheme()

  // System
  const { t } = useTranslation([
    'network.career_website',
    'main.talent',
    'main.worker',
  ])

  // Queries
  const { data: institutionData, isLoading: institutionIsLoading } =
    useGetPublicCareerSiteQuery(slug as string)

  return (
    <Stack sx={{ gap: { xs: 2, md: 4 } }}>
      {institutionData?.presentation && (
        <>
          <Stack sx={{ gap: 2 }}>
            <Heading2 sx={{ display: { xs: 'none', md: 'block' } }}>
              {t('content_generated.institution_presentation.title')}
            </Heading2>
            <TextBody>{institutionData?.presentation}</TextBody>
          </Stack>
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              backgroundColor: theme.palette.border.subtle,
              height: '1px',
              width: '100%',
            }}
          />
        </>
      )}
      {institutionData?.workEnvironment && (
        <>
          <Stack sx={{ gap: 2 }}>
            <Heading2>{t('content_generated.work_atmosphere.title')}</Heading2>
            <TextBody>{institutionData?.workEnvironment}</TextBody>
          </Stack>
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              backgroundColor: theme.palette.border.subtle,
              height: '1px',
              width: '100%',
            }}
          />
        </>
      )}
      {!institutionIsLoading &&
        !institutionData?.presentation &&
        !institutionData?.workEnvironment && (
          <EmptyState
            data-testid="JobOffers__JobOffersContainer__EmptyStateNoResultsNoFilters"
            icon={<WorkOutlineOutlined fontSize="large" />}
            title={t('network.career_website:public.no_presentation')}
            message={t(
              'network.career_website:public.no_presentation_description',
            )}
          />
        )}
    </Stack>
  )
}
